export default "__VITE_ASSET__DDK3C6Yv__"